import axios from '@/xaxios';
import { getApiFactura, FACTURAS_BASE_PATH } from './facturafacil';
 
let TOKEN_RUC = ""

const isTokenExpired = (token) => {
  if(!token) return {expired:true}
  try {
    // Dividir en partes (header, payload, signature)
    const parts = token.split(".");
    if (parts.length !== 3) {
      throw new Error("Token inválido");
    }

    // Decodificar payload Base64URL
    const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));

    // Revisar exp
    if (!payload.exp) {
      return { expired: null, message: "El token no tiene campo 'exp'" };
    }

    const now = Math.floor(Date.now() / 1000); // tiempo actual en segundos
    const expired = now >= payload.exp;

    return {
      expired,
      expDate: new Date(payload.exp * 1000).toLocaleString(),
      nowDate: new Date(now * 1000).toLocaleString(),
    };
  } catch (err) {
    return { error: err.message };
  }
}

export const buscar_ruc = async (ruc, unidad, sede) => {
  let exp = isTokenExpired(TOKEN_RUC)

  let apidev = process.env.VUE_APP_GRAPHQL;
  let TEST = apidev.includes("apidev")
  const datas = {
    "channel":"PANEL",
    "email": "diego.saldias@esam.edu.bo",
    "password": "ZKZR2HMP"
  }
  let url = `${FACTURAS_BASE_PATH}/proxy2/https://api.facturafacil.com.pa/api/custom_auth/user/token/`
  if(TEST) {
    url = `${FACTURAS_BASE_PATH}/proxy/api/custom_auth/user/token/`
    datas.email = "demo@esam"
    datas.password = "MS5L6LML"
  }


  if(exp.expired){
    
    const ntoken = await axios
        .post(
          url,
          datas,
          {
            headers: {},
          },
        ).then(({ data }) => data).catch((e) => e);
      if(ntoken && ntoken.access) TOKEN_RUC = ntoken.access
        // window.console.log('ntoken',ntoken);
  }

  const apisdata = getApiFactura(unidad, sede);
  

  let url2 = `${FACTURAS_BASE_PATH}/proxy2/https://api.facturafacil.com.pa/api/pos/master/customer/find_by_ruc/`
  if(TEST) url2 = FACTURAS_BASE_PATH+'/proxy/api/pos/master/customer/find_by_ruc/'


  return await axios
    .get(
      url2, 
      {
      params: { ruc: ruc, ruc_type: -1 },
      headers: {
        Authorization:
          `Bearer ${TOKEN_RUC}`,
          'x-ff-company': apisdata.X_FF_COMPANY,
      },
    })
    .then(({ data }) => data)
    .catch((e) => e);
};
